<template>
  <div>
    <div style="overflow-y: scroll; height: 90vh; padding: 15px; background-color: #ffffff;">
      <h2 class="mb-3">My Compliance Dashboard​</h2>
      <b-row>
        <b-col cols="4">
          <h6>Policies (2)</h6>
          <b-card
            bg-variant="default"
            class="mb-2 click-cursor card-wrapper"
          >
            <b-card-text class="my-5">
              <font-awesome-icon
                icon="file-signature"
                size="6x"
                style="color: #3ddc97"
              />
            </b-card-text>
            <b-card-text>
              <b-button variant="primary">Not Started</b-button>
            </b-card-text>
            <b-card-text>
              <b-button variant="outline-primary">Start</b-button>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="4">
          <h6>Trainings (1)​</h6>
          <b-card
            bg-variant="default"
            class="mb-2 click-cursor card-wrapper"
          >
            <b-card-text class="my-5">
              <font-awesome-icon
                icon="graduation-cap"
                size="6x"
                style="color: #3ddc97"
              />
            </b-card-text>
            <b-card-text>
              <b-button variant="primary">Not Started</b-button>
            </b-card-text>
            <b-card-text>
              <b-button variant="outline-primary">Start</b-button>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="4">
          <h6>Certifications (2)​</h6>
          <b-card
            bg-variant="default"
            class="mb-2 click-cursor card-wrapper"
          >
            <b-card-text class="my-5">
              <font-awesome-icon
                icon="certificate"
                size="6x"
                style="color: #3ddc97"
              />
            </b-card-text>
            <b-card-text>
              <b-button variant="primary">Not Started</b-button>
            </b-card-text>
            <b-card-text>
              <b-button variant="outline-primary">Start</b-button>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row
        style="margin-top: 25px"
        align-h="center"
      >
        <b-col cols="4">
          <h6>My <span style="color: red">Approvals</span>​</h6>
          <b-card
            bg-variant="default"
            class="mb-2 click-cursor card-wrapper"
          >
            <b-card-text class="my-5">
              <font-awesome-icon
                icon="check-circle"
                size="6x"
                style="color: #3ddc97"
              />
            </b-card-text>
            <b-card-text>
              <b-button variant="primary">Not Started</b-button>
            </b-card-text>
            <b-card-text>
              <p>Fill out forms for approval​</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="4">
          <h6>Complaints Hotline​</h6>
          <b-card
            bg-variant="default"
            class="mb-2 click-cursor card-wrapper"
          >
            <b-card-text class="my-5">
              <font-awesome-icon
                icon="comments"
                size="6x"
                style="color: #3ddc97"
              />
            </b-card-text>
            <b-card-text>
              <b-button variant="primary">Not Started</b-button>
            </b-card-text>
            <b-card-text>
              <p>File a complaint​</p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewDashboardTheme",
  data () {
    return {

    };
  },
};
</script>

<style>
</style>